module.exports = __webpack_public_path__ + "static/media/waze3.ea265041.png";